// src/components/SelectShipToParty.js
import React, { useState, useEffect, forwardRef } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Container,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Divider,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  Card,
  CardHeader,
  Tooltip,
  CardContent,
  AccordionDetails,
  CircularProgress,
  Checkbox,
  CardActions,
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCompanyAndRoleAction } from '../Onboarding/auth/action';
import { useDispatch, useSelector } from 'react-redux';
import { notification, Row } from 'antd';
import {
  GetCompanyDetailsByPhoneNumber,
  GetUserTransactionDetailsByBuyerNow,
  getPhoneNumberViaGstinAction,
  getPhoneNumberViaPanAction,
} from '../../screen/distributor/action/util_action';
import {
  decodeToken,
  searchByTypes,
  transactionType,
  unitCaseEnum,
} from '../../utils/settings';
import { useLocation, useNavigate } from 'react-router-dom';
import { createOrder, getIsFMCG } from '../../screen/auth/action';
import dayjs from 'dayjs';
import {
  Check,
  Close,
  Delete,
  Edit,
  ExpandMore,
  Warning,
} from '@mui/icons-material';
import ShipToPartyDetails from './ShipToPartyDetails';
import { styled } from '@mui/system';
import AddRemoveQty from '../Components/AddRemoveQty';
import MouseOverPopover from '../MyAccount/Container/HoverPopover';
import ShipToPartyDetailsComponents from './ShipToPartyDetailsComponents';
import { getOrderCalculations } from '../../screen/distributor/action/easebuzz_utils';
import PreviewModal from './PreviewModal';
import GoBack from '../Components/GoBack';
import WarningModal from '../Components/WarningModal';

const SelectedShipToPartyList = () => {
  const [CompanyRoleData, setCompanyRoleData] = useState([]);
  const [userType, setUserType] = useState({});
  const [allBuyers, setAllBuyers] = useState([]);
  const [editFirm, setEditFirm] = useState(false);
  const [productList, setProductList] = useState([]);
  const [decodedData, setDecodedData] = useState({});
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [open, handleModalClose] = useState(false);

  const [pricesObj, setPricesObj] = useState({
    total: 0,
    gst: 0,
    discounts: 0,
    qtyTotal: 0,
    toPay: 0,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [decodedTokenData, setDecodedTokenData] = useState({});
  const [cashDiscount, setCashDiscount] = useState({});
  const [applyDiscount, setApplyDiscount] = useState(false);

  useEffect(() => {
    decodeToken().then((data) => {
      setDecodedTokenData(data);
    });
  }, []);

  const { state } = useLocation();

  const {
    addedUserList,
    booking_details,
    isPaintFlow,
    seller_id,
    supplier_id,
    cart,
    isSecondaryOrder,
    isFmcgFlow,
    skuMaster,
    companyDetails,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      booking_details: state.bcmOrderReducer.booking_details,
      isPaintFlow: state.bcmOrderReducer.isPaintFlow,
      seller_id: state.bcmOrderReducer.seller_id,
      supplier_id: state.bcmOrderReducer.supplier_id,
      cart: state.orderReducer.cart,
      isSecondaryOrder: state.bcmOrderReducer.isSecondaryOrder,
      isFmcgFlow: state.bcmOrderReducer.isFmcgFlow,
      skuMaster: state.orderReducer.skuMaster,
      companyDetails: state.fmcgReducer.companyDetails,
    };
  });

  const [sellerID, setSellerID] = useState(
    booking_details.seller_company_id || seller_id,
  );

  const getPricesAndDiscounts = (productList) => {
    let total = 0;
    let discounts = 0;
    let toPay = 0;
    productList.map((item) => {
      if (state?.isComingFromPdp) {
        total += Number(item?.mrp) * Number(item.qty);
        discounts += Number(item?.discounts) * Number(item.qty);
        toPay += Number(item?.landing_price) * Number(item.qty);
      } else {
        total += Number(item?.mrp) * Number(item.qty) * Number(item.multiplier);
        discounts +=
          Number(item?.discounts) * Number(item.qty) * Number(item.multiplier);
        toPay +=
          Number(item?.landing_price) *
          Number(item.qty) *
          Number(item.multiplier);
      }
    });
    setPricesObj({
      ...pricesObj,
      total: total,
      discounts: discounts,
      toPay: toPay,
    });
  };
  const getOrderCost = async (addedUserList) => {
    if (addedUserList && addedUserList.length === 0) return;
    if (!decodedTokenData?.default_company_info?.company_id) return;
    const payload = {
      order_products_delivery: addedUserList?.map((item) => {
        return {
          ship_to_party_info: {
            so_id: null,
            deliver_to: item.company_id,
            company_name: item.company_name,
            requested_district_id: item.delivery_district_id,
            incoterms: item?.incoterms || null,
            company_gstin: item?.gstin,
            company_pan: item?.pancard_no,
            company_phone_no: item?.company_phone_no,
            delivery_address: {
              address_line_1: item?.delivery_Address_line1,
              address_line_2: item?.delivery_Address_line2,
              address_line_3: item?.delivery_Address_line3,
            },
            location_id: item?.delivery_location_id
              ? item?.delivery_location_id
              : item?.location_id,
            location_name: item?.delivery_location_name
              ? item?.delivery_location_name
              : item?.location_name,
            pricing_geography_id: item?.delivery_pricing_geography_id
              ? item?.delivery_pricing_geography_id
              : item?.pricing_geography_id,
            pricing_geography_name: item?.delivery_pricing_geography_name
              ? item?.delivery_pricing_geography_name
              : item?.pricing_geography_name,
            pincode: item?.delivery_company_pincode
              ? item?.delivery_company_pincode
              : item?.company_pincode,
            // requested_district_name: 'string',
            // state_name: 'string',
            // incoterms_display_name: 'string',
            // delivery_type_name: 'string',
            delivery_type: item?.delivery_type || null,
            requested_dispatch_date: item?.requested_dispatch_date || null,
            order_delivery_contact_no: item?.order_delivery_contact_no || '',
            order_delivery_contact_person_name:
              item?.order_delivery_contact_person_name || '',
          },
          products_info:
            item?.products?.length === 0
              ? []
              : isPaintFlow
              ? item?.products?.map((prod) => {
                  return {
                    order_product_delivery_id: null,
                    product_id: prod.product_id,
                    quantity: {
                      // quantity_in_bags: 0,
                      quantity_in_bags: isSecondaryOrder
                        ? Number(prod.qty)
                        : null,
                      quantity_in_metric_ton: isSecondaryOrder
                        ? null
                        : Number(prod.qty),
                      multiplier: Number(prod.product_multiplier),
                      unit: prod.product_data.meta_data.unit,
                      base_unit: prod.product_data.meta_data.base_unit,
                    },
                  };
                })
              : item.products?.map((prod) => ({
                  product_id: prod.product_id,
                  quantity: {
                    quantity_in_metric_ton: Number(prod.qty),
                    multiplier: Number(prod.meta_data.multiplier),
                    units: prod.meta_data.unit,
                    base_unit: prod.meta_data.base_unit,
                  },
                })),
        };
      }),
      order_booking_id: booking_details?.booking_id || null,
      order_id: null,
      cash_discount_config: {
        ...companyDetails.cash_discount_config,
        is_applicable: applyDiscount,
      },
      buyer_id: decodedTokenData.default_company_info.company_id,
    };

    if (!isPaintFlow) {
      payload.seller_id = isSecondaryOrder
        ? supplier_id.id
        : booking_details.seller_company_id;
      payload.supplier_id = isSecondaryOrder
        ? seller_id
        : booking_details.seller_company_id;
    } else {
      payload.seller_id = isSecondaryOrder ? supplier_id.id : seller_id;
      payload.supplier_id = seller_id;
    }
    setLoading(true);
    const { error, data, message } = await getOrderCalculations(payload);
    setLoading(false);
    if (error) {
      setCashDiscount({});
    } else {
      setCashDiscount(data);
    }
  };

  const handleEditDeliveryDetails = (buyerData) => {
    dispatch({
      type: 'UPDATE_USER_TO_LIST',
      data: buyerData,
    });
  };

  useEffect(() => {
    getOrderCost(addedUserList);
  }, [decodedTokenData, applyDiscount]);

  const onCreateOrder = async () => {
    let payload = {};
    if (!isPaintFlow) {
      payload = {
        seller_id: isSecondaryOrder
          ? supplier_id.id
          : booking_details.seller_company_id,
        supplier_id: isSecondaryOrder
          ? seller_id
          : booking_details.seller_company_id,
        order_products_delivery: addedUserList?.map((vv) => ({
          ship_to_party_info: {
            deliver_to: vv.company_id,
            company_name: vv.company_name,
            delivery_address: {
              address_line_1: vv?.delivery_Address_line1,
              address_line_2: vv?.delivery_Address_line2,
              address_line_3: vv?.delivery_Address_line3,
            },
            order_product_delivery_type: vv.delivery_type,
            order_delivery_contact_no: vv.delivery_contact_person_phone,
            order_delivery_contact_person_name: vv.delivery_contact_person_name,
            requested_district_id: vv.delivery_district_id,
            requested_dispatch_date: dayjs(vv.dispatch_date).format(
              'YYYY-MM-DD',
            ),
            requested_pincode: vv.delivery_company_pincode
              ? vv.delivery_company_pincode
              : vv.company_pincode,
            incoterms: vv.incoterms,
            location_id: vv?.delivery_location_id
              ? vv?.delivery_location_id
              : vv?.location_id,
            pricing_geography_id: vv?.delivery_pricing_geography_id
              ? vv?.delivery_pricing_geography_id
              : vv?.pricing_geography_id,
          },
          products_info: vv.products?.map((prod) => ({
            form_type: prod.form_type,
            product_id: prod.product_id,
            quantity: {
              quantity_in_metric_ton: Number(prod.qty),
              multiplier: Number(prod.meta_data.multiplier),
              units: prod.meta_data.unit,
            },
            length: prod.length,
            remark: prod.remarks,
          })),
        })),
        order_booking_id: booking_details.booking_id,
      };
    } else {
      payload = {
        seller_id: isSecondaryOrder ? supplier_id.id : seller_id,
        supplier_id: seller_id,
        order_products_delivery: addedUserList?.map((vv) => ({
          ship_to_party_info: {
            deliver_to: vv.company_id,
            company_name: vv.company_name,
            delivery_address: {
              address_line_1: vv?.delivery_Address_line1,
              address_line_2: vv?.delivery_Address_line2,
              address_line_3: vv?.delivery_Address_line3,
            },
            order_delivery_contact_no: vv.delivery_contact_person_phone,
            order_delivery_contact_person_name: vv.delivery_contact_person_name,
            requested_district_id: vv.delivery_district_id,
            requested_dispatch_date: dayjs(vv.dispatch_date).format(
              'YYYY-MM-DD',
            ),
            requested_pincode: vv.delivery_company_pincode
              ? vv.delivery_company_pincode
              : vv.company_pincode,
            location_id: vv?.delivery_location_id
              ? vv?.delivery_location_id
              : vv?.location_id,
            pricing_geography_id: vv?.delivery_pricing_geography_id
              ? vv?.delivery_pricing_geography_id
              : vv?.pricing_geography_id,
          },
          products_info: vv.products?.map((prod) => {
            const isInUnit = prod.product_size === unitCaseEnum['UNIT'];
            return {
              product_id: prod.product_id,
              quantity: {
                quantity_in_bags: isSecondaryOrder ? Number(prod.qty) : null,
                quantity_in_metric_ton: isSecondaryOrder
                  ? null
                  : Number(prod.qty),
                multiplier: Number(prod.product_multiplier),
                units: isInUnit ? 'Unit' : 'Case(s)',
              },
            };
          }),
        })),
      };
    }

    payload.cash_discount_config = {
      ...companyDetails.cash_discount_config,
      is_applicable: applyDiscount,
    };

    if (isSecondaryOrder) {
      payload.buyer_id = addedUserList[0].company_id;
    }

    setLoading(true);
    const { data, error, message } = await createOrder(payload);
    setLoading(false);

    if (!error) {
      setShowSummary(false);
      toast.success(message);
      
      setTimeout(() => {
        navigate('/order-booking/dispatch-status-list');
      }, 1000);
    } else {
      return toast.error(message);
    }
  };
  const getCartItems = (list) => {
    let cartItems = [];
    if (list && list.length > 0) {
      cartItems = list.map((item) => {
        const product = item.product_data;
        const { meta_data } = product;
        return {
          image: product.product_logo,
          product_name: product.name,
          mrp: product.meta_data.MRP,
          landing_price: isSecondaryOrder
            ? product.meta_data.price.rlp
            : product.meta_data.price.dlp,
          qty: item.qty,
          prod_id: product.product_id,
          discounts: isSecondaryOrder
            ? product.meta_data.MRP - product.meta_data.price.rlp
            : product.meta_data.MRP - product.meta_data.price.dlp,
          multiplier: Number(product.meta_data.multiplier),
          base_unit: product.meta_data.base_unit,
          unit: product.meta_data.unit,
          packingType:
            item?.product_size === unitCaseEnum['CASE']
              ? meta_data.unit
              : meta_data.base_unit,
        };
      });
    }

    return cartItems;
  };

  const getTotalQty = (item) => {
    if (item?.products == null || item?.products.length === 0) return 0;
    return item.products.reduce((acc, item) => {
      return acc + Number(item.qty);
    }, 0);
  };

  const handleEditFirmDiscardClick = () => {
    setEditFirm(false);
  };

  const handleEditFirmClick = async (firm) => {
    const payload = {
      id: firm?.company_id,
      name: firm?.company_name,
    };
    // if (editFirm) await onUpdate(payload);
    setEditFirm(!editFirm);
  };
  const handleValueChange = (value, productDetails, stpIndex) => {
    const obj = {
      ...productDetails,
      qty: `${value}`,
    };

    dispatch({
      type: 'REPLACE_PRODUCT_QTY_OF_STP',
      payload: {
        stpIndex: stpIndex,
        productDetails: obj,
      },
    });
    getOrderCost(addedUserList);
  };
  const [showCheckout, setShowCheckout] = useState(false);
  useEffect(() => {
    const showCheckoutButton = addedUserList?.map((item) => {
      return item?.products?.length > 0;
    });
    setShowCheckout(!showCheckoutButton.includes(false));
  }, [addedUserList]);

  useEffect(() => {
    getOrderCost(addedUserList);
  }, [addedUserList]);
  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        <GoBack
          title={'Cart Summary'}
          onBack={() => handleModalClose(true)}
        />

        {addedUserList.length > 0 && (
          <>
            {addedUserList.map((firm, index) => {
              return (
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    sx={{ py: 1 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexGrow: 1,
                      }}
                    >
                      <Typography
                        fontSize={'1rem'}
                        fontWeight={'bold'}
                        sx={{ mr: 1, flexGrow: 1 }}
                      >
                        {firm.company_name}
                      </Typography>
                      <Button
                        variant='outlined'
                        size='small'
                        sx={{
                          // color: '#F59C1E',
                          fontWeight: 'bold',
                          fontSize: '0.7rem',
                          maxHeight: '30px',
                          mr: '1rem',
                        }}
                        onClick={() => {
                          if (isPaintFlow) {
                            dispatch({
                              type: 'SET_SELECTED_STP',
                              data: firm,
                            });

                            dispatch({
                              type: 'SET_USER_INDEX',
                              data: index,
                            });
                            navigate('/order-booking/product-list', {
                              state: {
                                distributor_id: sellerID,
                              },
                            });
                          } else {
                            navigate('/order-booking/add-products', {
                              state: {
                                index: index,
                                product_list: firm?.products,
                              },
                            });
                          }
                        }}
                      >
                        {firm?.products?.length > 0
                          ? 'Add More Products'
                          : 'Add Products'}
                      </Button>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        sx={{ py: 1 }}
                      >
                        <Typography
                          fontSize={'1rem'}
                          fontWeight={'bold'}
                          sx={{ mr: 1, flexGrow: 1 }}
                        >
                          Ship To Party Details
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Card sx={{ mt: '1rem' }}>
                          <CardHeader
                            title='Details'
                            sx={{ backgroundColor: '#f5f5f5' }}
                            action={
                              <Stack
                                direction='row'
                                spacing={2}
                              >
                                <Tooltip title='Delete'>
                                  {/* {!(isFmcgFlow || isPaintFlow) && ( */}
                                  <IconButton
                                    onClick={() => {
                                      dispatch({
                                        type: 'REMOVE_USER_FROM_LIST',
                                        data: firm,
                                      });
                                    }}
                                  >
                                    <Delete color={'error'} />
                                  </IconButton>
                                  {/* )} */}
                                </Tooltip>
                              </Stack>
                            }
                          />

                          <CardContent>
                            <ShipToPartyDetailsComponents
                              firm={firm}
                              editFirm={editFirm}
                              handleEditDeliveryDetails={
                                handleEditDeliveryDetails
                              }
                              showSaveButton={true}
                            />
                          </CardContent>
                        </Card>
                      </AccordionDetails>
                    </Accordion>

                    <Stack direction={'row'}>
                      <Card sx={{ mt: '1rem', width: '100%' }}>
                        <CardHeader
                          title='Product Summary'
                          sx={{ backgroundColor: '#f5f5f5' }}
                        />

                        <CardContent>
                          {state?.isComingFromPdp ||
                          isFmcgFlow ||
                          isPaintFlow ? (
                            <TableContainer component={Paper}>
                              <Table aria-label='simple table'>
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      align={'center'}
                                      sx={{ fontWeight: 'bold' }}
                                    >
                                      Product
                                    </TableCell>
                                    <TableCell
                                      align={'center'}
                                      sx={{ fontWeight: 'bold' }}
                                    >
                                      UOM
                                    </TableCell>
                                    <TableCell
                                      align={'left'}
                                      sx={{ fontWeight: 'bold' }}
                                    >
                                      Price
                                    </TableCell>
                                    <TableCell
                                      align={'center'}
                                      sx={{ fontWeight: 'bold', pr: '5rem' }}
                                    >
                                      Quantity
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {getCartItems(firm.products).map(
                                    (item, productIindex) => (
                                      <TableRow key={item.prod_id}>
                                        <TableCell sx={{ width: '50%' }}>
                                          <Stack direction={'row'}>
                                            <Box
                                              component='img'
                                              sx={{
                                                height: 120,
                                                width: 150,
                                              }}
                                              alt={item.product_name}
                                              src={item.image}
                                            />
                                            <Box>
                                              <Typography
                                                sx={{ fontWeight: 'bold' }}
                                              >
                                                {item.product_name}
                                              </Typography>
                                              <Typography>
                                                1 {item.unit} ={' '}
                                                {item.multiplier}{' '}
                                                {item.base_unit}
                                              </Typography>
                                            </Box>
                                          </Stack>
                                        </TableCell>
                                        <TableCell align='left'>
                                          <Stack direction={'row'}>
                                            <Typography
                                              gutterBottom
                                              variant='subtitle1'
                                              component='div'
                                              sx={{
                                                fontWeight: 'bold',
                                              }}
                                            >
                                              {item.packingType}
                                            </Typography>
                                          </Stack>
                                        </TableCell>

                                        <TableCell align='left'>
                                          <Stack direction={'row'}>
                                            <Typography
                                              gutterBottom
                                              variant='subtitle1'
                                              component='div'
                                              sx={{
                                                textDecoration: 'line-through',
                                                fontWeight: 'bold',
                                              }}
                                            >
                                              ₹ {item.mrp}
                                            </Typography>

                                            <Typography
                                              variant='subtitle1'
                                              color='text.secondary'
                                              sx={{
                                                ml: '0.5rem',
                                                color: '#1fd655',
                                                fontWeight: 'bold',
                                              }}
                                            >
                                              ₹ {item.landing_price}
                                            </Typography>
                                          </Stack>
                                        </TableCell>

                                        <TableCell align={'center'}>
                                          <Stack direction={'row'}>
                                            <Grid
                                              container
                                              justifyContent='flex-end'
                                            >
                                              <AddRemoveQty
                                                quantity={item.qty}
                                                onIncreasePress={() => {
                                                  dispatch({
                                                    type: 'INCREMENT_PRODUCT_QTY_OF_STP',
                                                    payload: {
                                                      stpIndex: index,
                                                      product_id: item.prod_id,
                                                      multiplier:
                                                        item.multiplier,
                                                    },
                                                  });
                                                  getOrderCost(addedUserList);
                                                }}
                                                onReducePress={() => {
                                                  dispatch({
                                                    type: 'DECREMENT_PRODUCT_QTY_OF_STP',
                                                    payload: {
                                                      stpIndex: index,
                                                      product_id: item.prod_id,
                                                      multiplier:
                                                        item.multiplier,
                                                    },
                                                  });
                                                }}
                                                onTextChange={(value) => {
                                                  handleValueChange(
                                                    value,
                                                    firm.products[
                                                      productIindex
                                                    ],
                                                    index,
                                                  );
                                                }}
                                              />
                                            </Grid>

                                            <Grid
                                              container
                                              justifyContent='flex-end'
                                              sx={{ width: '60%' }}
                                            >
                                              <Tooltip title='Discard'>
                                                <IconButton
                                                  onClick={() => {
                                                    dispatch({
                                                      type: 'REMOVE_PRODUCT_QTY_OF_STP',
                                                      payload: {
                                                        stpIndex: index,
                                                        product_id:
                                                          item.prod_id,
                                                      },
                                                    });
                                                    getOrderCost(addedUserList);
                                                  }}
                                                >
                                                  <Delete
                                                    sx={{ color: '#FF0000' }}
                                                  />
                                                </IconButton>
                                              </Tooltip>
                                            </Grid>
                                          </Stack>
                                        </TableCell>
                                      </TableRow>
                                    ),
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <>
                              {firm?.products && firm?.products.length > 0 && (
                                <TableContainer component={Paper}>
                                  <Table aria-label='simple table'>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align={'center'}>
                                          #
                                        </TableCell>
                                        <TableCell align={'center'}>
                                          Product Name
                                        </TableCell>
                                        <TableCell align={'center'}>
                                          Quantity
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {firm?.products?.map(
                                        (product, productIndex) => (
                                          <TableRow key={product.product_id}>
                                            <TableCell align={'center'}>
                                              {productIndex + 1}
                                            </TableCell>
                                            <TableCell align={'center'}>
                                              <MouseOverPopover
                                                text={product.product_name}
                                                popOverText={product.remarks}
                                              />
                                            </TableCell>
                                            <TableCell align={'center'}>
                                              <Stack direction={'row'}>
                                                <Grid
                                                  container
                                                  justifyContent='flex-end'
                                                >
                                                  <AddRemoveQty
                                                    quantity={product.qty}
                                                    onIncreasePress={() => {
                                                      dispatch({
                                                        type: 'INCREMENT_PRODUCT_QTY_OF_STP',
                                                        payload: {
                                                          stpIndex: index,
                                                          product_id:
                                                            product.product_id,
                                                        },
                                                      });
                                                    }}
                                                    onReducePress={() => {
                                                      dispatch({
                                                        type: 'DECREMENT_PRODUCT_QTY_OF_STP',
                                                        payload: {
                                                          stpIndex: index,
                                                          product_id:
                                                            product.product_id,
                                                        },
                                                      });
                                                    }}
                                                    onTextChange={(value) =>
                                                      handleValueChange(
                                                        value,
                                                        product,
                                                        index,
                                                      )
                                                    }
                                                  />
                                                </Grid>

                                                <Grid
                                                  container
                                                  justifyContent='flex-end'
                                                  sx={{ width: '60%' }}
                                                >
                                                  <Tooltip title='Discard'>
                                                    <IconButton
                                                      onClick={() => {
                                                        // removeProductFromList(product)
                                                        dispatch({
                                                          type: 'REMOVE_PRODUCT_QTY_OF_STP',
                                                          payload: {
                                                            stpIndex: index,
                                                            product_id:
                                                              product.product_id,
                                                          },
                                                        });
                                                        getOrderCost(
                                                          addedUserList,
                                                        );
                                                      }}
                                                    >
                                                      <Delete
                                                        sx={{
                                                          color: '#FF0000',
                                                        }}
                                                      />
                                                    </IconButton>
                                                  </Tooltip>
                                                </Grid>
                                              </Stack>
                                            </TableCell>
                                          </TableRow>
                                        ),
                                      )}
                                      <TableRow>
                                        <TableCell
                                          sx={{ fontWeight: 'bold' }}
                                          colSpan={2}
                                          align={'center'}
                                        >
                                          Total
                                        </TableCell>
                                        <TableCell
                                          align={'center'}
                                          sx={{
                                            fontWeight: 'bold',
                                          }}
                                        >{`${getTotalQty(firm)} ${
                                          firm.products[0]?.meta_data?.unit
                                        }`}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              )}
                            </>
                          )}
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              mt: '2rem',
                            }}
                          ></Box>
                        </CardContent>
                      </Card>
                    </Stack>
                  </AccordionDetails>

                  <Box sx={{ mt: '3rem', mb: '1rem' }} />
                </Accordion>
              );
            })}
          </>
        )}
        {addedUserList.length > 0 &&
          addedUserList.every((vv) => vv?.products?.length > 0) && (
            <Card sx={{ mt: '2rem' }}>
              <Row
                style={{
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant='h5'
                  sx={{
                    marginLeft: 2,
                    marginRight: 5,
                    marginTop: 2,
                  }}
                >
                  Cart Total
                </Typography>

                {companyDetails?.cash_discount_config?.is_applicable && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={applyDiscount}
                        onChange={(e) => setApplyDiscount(e.target.checked)}
                      />
                    }
                    label='Apply Discount'
                  />
                )}
              </Row>
              <CardContent>
                {cashDiscount?.order_summary_info?.total_bill_info?.map(
                  (item) => {
                    return (
                      <Stack
                        direction={'row'}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Typography>{item.display_name}: </Typography>
                        <Typography>
                          {loading ? (
                            <CircularProgress
                              sx={{ color: 'orange' }}
                              size={20}
                            />
                          ) : (
                            `₹ ${Number(item.value)}`
                          )}
                        </Typography>
                      </Stack>
                    );
                  },
                )}
              </CardContent>
            </Card>
          )}
        <Grid
          direction={'row'}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: '2rem',
            mb: '2rem',
          }}
        >
          {!isSecondaryOrder && addedUserList?.length < 3 && (
            <Button
              variant='outlined'
              onClick={() => navigate('/order-booking/select-ship-to-party')}
              sx={{
                marginRight: '2rem',
                backgroundColor: 'Background',
              }}
            >
              Add another ship to party
            </Button>
          )}

          {showCheckout && (
            <Button
              variant='contained'
              onClick={() => {
                setShowSummary(true);
                // onCreateOrder();
              }}
              sx={{ fontWeight: 'bold', width: 200 }}
              disabled={loading}
              startIcon={
                loading && (
                  <CircularProgress
                    sx={{ color: 'white' }}
                    size={20}
                  />
                )
              }
            >
              {loading ? 'Loading...' : 'Proceed'}
            </Button>
          )}
        </Grid>
      </Container>

      <PreviewModal
        visible={showSummary}
        onClose={() => setShowSummary(false)}
        calculationData={cashDiscount}
        loading={loading}
        onFinish={onCreateOrder}
      />
      <WarningModal
        open={open}
        handleModalClose={handleModalClose}
      />
    </>
  );
};

export default SelectedShipToPartyList;

const blue = {
  100: '#daecff',
  200: '#b6daff',
  300: '#66b2ff',
  400: '#3399ff',
  500: '#007fff',
  600: '#0072e5',
  700: '#0059B2',
  800: '#004c99',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const StyledInputRoot = styled('div')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled('input')(
  ({ theme }) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
  };
  border-radius: 8px;
  margin: 0 8px;
  padding: 10px 12px;
  outline: 0;
  min-width: 0;
  width: 4rem;
  text-align: center;

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${
      theme.palette.mode === 'dark' ? blue[700] : blue[200]
    };
  }

  &:focus-visible {
    outline: 0;
  }
`,
);

const StyledButton = styled('button')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 999px;
  border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
    border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
    color: ${grey[50]};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);
